import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Contact from "../components/Contact";

export default function ContactPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="contact-page" className="pt-24">
      <div className="max-w-[1280px] mx-auto px-6 mb-4">
        <nav className="flex items-center gap-2 text-sm text-[#a6b3c8]" style={{ fontFamily: "Sora, sans-serif" }}>
          <Link to="/" className="hover:text-white">Home</Link>
          <ChevronRight size={14} className="opacity-60" />
          <span className="text-white">Contact</span>
        </nav>
      </div>
      <Contact />
    </div>
  );
}
